module.exports = __webpack_public_path__ + "static/pic-891b1c46f41279e9c7cc01578ccbf207.svg";